import { MaterialModule } from './../../../core/modules/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelInfoComponent } from './panel-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    FlexLayoutModule
  ],
  declarations: [PanelInfoComponent],
  exports: [PanelInfoComponent],
})
export class PanelInfoModule { }



// WEBPACK FOOTER //
// ./src/app/main/components/panel-info/panel-info.module.ts